import { URI_REPORT } from '@/config/config'

export default async ({ rootState }, {
  firstPeriodStart,
  firstPeriodEnd,
  secondPeriodStart,
  secondPeriodEnd }) => {

  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken
    },
    body: JSON.stringify({
      firstStartPeriod: firstPeriodStart,
      firstEndPeriod: firstPeriodEnd,
      secondStartPeriod: secondPeriodStart,
      secondEndPeriod: secondPeriodEnd
    })
  }

  const userLoginInfoResult = await fetch(`${URI_REPORT}dashboard/parking-use`, opts)
  return userLoginInfoResult.json()
}